import Button from "@components/Button";
import styles from "./ConfirmDetailsPoup.module.css";
import usePopup from "@hooks/usePopup";

const fieldNameMappings = {
  firstName: "First Name",
  lastName: "Last Name",
  referenceNo: "Reference No",
  instituteName: "Institute",
  address: "Address",
  pincode: "Pincode",
  province: "Province",
  country: "Country",
};

const ConfirmDetailsPopup = ({ details, onConfirm, onClose }) => {
  const { handlePopupCenterOpen } = usePopup();

  const handleClose = () => {
    handlePopupCenterOpen(false);
  };
  return (
    <div className={styles.Wrapper}>
      <h1>Confirm Details</h1>
      {/* <div className={styles.ContentWrapper}> */}
      {Object.entries(details).map(([key, value]) => (
        <div key={key} className={styles.DetailItem}>
          <span className={styles.DetailKey}>
            {fieldNameMappings[key] || key}:{" "}
          </span>
          <p className={styles.DetailValue}>{value.toString()}</p>
        </div>
      ))}
      {/* </div> */}
      <div className={styles.ButtonWrapper}>
        <Button text={"Confirm"} btnType={"primary"} onClick={onConfirm} />
        <Button text={"Cancel"} onClick={onClose ? onClose : handleClose} />
      </div>
    </div>
  );
};

export default ConfirmDetailsPopup;
